import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const toiletTrainingNotWorking: BlogMetaData = {
  title: 'トイトレがうまくいかない｜お漏らし・後戻り・拒否の原因と対処法',
  description:
    'トイトレがうまくいかない原因を、お漏らし・後戻り・トイレ拒否のケース別に解説。今日からできる対処法とやってはいけない対応を、モンテッソーリの視点でまとめました。失敗も後戻りも自然なことです。',
  thumbnailUrl: '/img/blog-toilet-training-not-working.webp',
  filePath: buildBlogFilePath('toilet-training-not-working'),
  category: BLOG_CATEGORY.PARENTING,
};
